
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/model/seedance2",
      function () {
        return require("private-next-pages/model/seedance2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/model/seedance2"])
      });
    }
  